import classNames from 'classnames';
import wallet from 'src/assets/images/wallet.png';
import { DepositCryptoOption } from 'react-easyrocket';

interface CryptoPaymentMethodProps {
  method: DepositCryptoOption;
  handleCryptoMethodSelect?: (cryptoMethod: DepositCryptoOption) => void;
  isSelected: boolean;
}

export const CryptoPaymentMethod = ({
  method,
  handleCryptoMethodSelect,
  isSelected
}: CryptoPaymentMethodProps) => {
  const { title, name } = method;

  return (
    <div
      className={classNames(
        'rounded-[10px] relative w-[75px] 412:w-[85px] h-[80px] flex flex-col items-center justify-center p-[15px] gap-1 bg-wdap_nodapay_method_bg cursor-pointer',
        isSelected ? 'outline outline-offset-0 outline-2 outline-wdap_active_method_outline' : ''
      )}
      onClick={() => {
        handleCryptoMethodSelect?.(method);
      }}>
      {name ? (
        <img
          src={`https://bwcdnimage-001.easyrocket.net/${name}.png`}
          alt={`${name}-icon`}
          className="h-7 w-auto"
        />
      ) : (
        <img src={wallet} alt={title} className="object-contain h-7" />
      )}
      <p
        className={classNames(
          'text-xs max-w-full text-center break-words break-all overflow-hidden inline-block text-ellipsis whitespace-nowrap',
          isSelected ? '!text-wdap_nodapay_method_selected_text' : 'text-wdap_nodapay_method_text'
        )}>
        {title}
      </p>
    </div>
  );
};
